import { useCallback, useEffect, useState } from 'react';
import { useSessionContext } from '../../context/SessionContext';
import { log } from '../../tools/LogHelper';

/**
 * Publish and/or subscribe to when a new message is sent to a user
 * @param roomId
 * @param shouldSubscribe
 */
export function usePubSubNewUserMessage(
  userId: number,
  component = '',
  shouldSubscribe = false
) {
  const [refreshToken, setRefreshToken] = useState<string>();
  const { publish, subscribe, unsubscribe } = useSessionContext();
  const key = `/users/${userId}/new-room-message`;
  useEffect(() => {
    const callback = (refreshToken: string) => {
      log('pubSubNewUserMessage', refreshToken);
      setRefreshToken(refreshToken);
    };
    if (shouldSubscribe) {
      subscribe(key, component, callback);
      return () => unsubscribe(key, component, callback);
    }
  }, [key, component, shouldSubscribe, subscribe, unsubscribe]);
  const notifyNewUserMessage = useCallback(() => {
    publish(key, new Date().toString());
  }, [key, publish]);
  return {
    refreshToken,
    notifyNewUserMessage
  };
}
